import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20cinematic%20abstract%20background%20with%20warm%20peach%20and%20golden%20gradients%2C%20soft%20flowing%20particles%20of%20light%2C%20elegant%20curved%20shapes%2C%20modern%20minimalist%20design%2C%20dark%20bottom%20fading%20to%20warm%20tones%20at%20top%2C%20luxurious%20texture%2C%204K%20quality&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="桃子视频"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-sparkling-2-fill text-sm text-primary-300"></i>
            </div>
            <span className="text-sm text-primary-200 whitespace-nowrap">🎯 数字系列视频平台</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
            高清视频<span className="text-primary-400">免费看</span>
            <br />
            <span className="text-xl md:text-3xl lg:text-4xl">不卡顿 · 不缓冲 · 资源全</span>
          </h1>

          <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto mb-8 leading-relaxed">
            91视频、97视频、51视频、92视频、98视频、小蓝视频、妖精视频 —— 数字系列视频平台全覆盖，
            电影电视剧全集免费高清在线观看，极速加载，畅享观影体验
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/91-video"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-semibold text-base hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer text-center"
            >
              立即观看
            </Link>
            <Link
              to="/about"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="w-full sm:w-auto px-8 py-3.5 bg-white/10 text-white border border-white/20 rounded-full font-medium text-base hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer text-center"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">10万+</div>
              <div className="text-xs text-white/50 mt-1">视频资源</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">7个</div>
              <div className="text-xs text-white/50 mt-1">数字系列平台</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">5000万+</div>
              <div className="text-xs text-white/50 mt-1">月活跃用户</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}